export default {
  state: {
    ext: '',
    status: '',
    deviceName: '',
    deptid: '-1',
    deptname: '全部分区',
    network: '',
    infoExt: '',

    showStatus: false,
    showBroadCast: true,
    play_type: '',
    broadTypeId: '9-2',
    broadTypeName: 'state_bro',
    noticeTypeId: '-1',
    noticeTypeName: 'all_notice',
    actionPlanId: '',
    actionPlanName: 'all_plan',
    linkGroupId: '0',
    linkGroupName: 'all',
    linkGroupIsPublic: '1',
    linkGroupDeptId: false,
    alarmTypeId: '1',
    alarmArea: 'warning_unrelease',

    reportingInformationId: '',
    reportingInformationName: 'reporting_information_all_info',

    mapDevice: {name: '', lng: 121.473354, lat: 31.238413},
    clickMapLeft: false,
    mapType: 'BAIDU',
    editMap: false,
    mapGroupId: '0',
    mapGroupName: 'all_area',

    menuId: '',//缓存当前menuID
    hiddenMenuId: '',//缓存隐藏在显示更多的hiddenMenuId

    camera: {id: ''},
    cameraGroupName: 'all',
    call: false,
    hangup: false,
    videoModal: false,
    modalCameras: null,
    hangExten: '',
    alarm: false,
    alarmId: '',
    alarmExten: '',
    alarmType: '',
    clearSearch: false,
    needFresh: false,//上传信息是否需要刷新
    row_column_display_num: '4,5',//终端和会议室中终端行列数配置,默认4行5列
    autoAccept: false,

    //自检任务
    selfCheckArea: 'nowSelfCheck',
    selfCheckType: '0',

    //双屏显示地图编辑终端同步地图中的终端
    updateMapBaiDu: false,
    updateMapDevice: false,
    hourlyChimeArea: 'has_open',
    hourlyChimeType: '1',

    clickMonitorLeft: false,
    clickSurveillanceLeft: false,
    surveillanceFull: false,
    deptIds: [],
    autoCall: false,
    clickSystemId: '',
    clickSystemName: '',
    clickSystemAppKey: '',

    addMapPoint: {type: 0, id: ''},

    dispatch_deptId: '',
    dispatch_deptIds: [],
    dispatch_areaName: '',
    tempDeptId: '',
    tempDispatch:'',
    whitePhoneSelected: '',
  },
  mutations:{
    setAddMapPoint(state, point) {
      state.addMapPoint = point
    },
    setSurveillanceFull(state,type){
      state.surveillanceFull= type
    },
    setClickMonitorLeft(state,type){
      state.clickMonitorLeft= type
    },
    setClickSurveillanceLeft(state,type){
      state.clickSurveillanceLeft= type
    },
    setAutoCall(state, autoCall) {
      state.autoCall = autoCall
    },
    setHourlyChimeArea(state,area){
      state.hourlyChimeArea = area
    },
    setHourlyChimeType(state,type){
      state.hourlyChimeType = type
    },
    setDeptIds(state,deptIds) {
      state.deptIds = deptIds
    },
    setDispatchDeptId(state, dispatch_deptId) {
      state.dispatch_deptId = dispatch_deptId
    },
    setDispatchDeptIds(state, dispatch_deptIds) {
      state.dispatch_deptIds = dispatch_deptIds
    },
    setDispatchAreaName(state, dispatch_areName) {
      state.dispatch_areaName = dispatch_areName
    },
    setUpdateMapDevice(state,device){
      state.updateMapDevice = device
    },
    setUpdateMapBaiDu(state,baidu){
      state.updateMapBaiDu = baidu
    },
    setSelfCheckArea(state,area){
      state.selfCheckArea = area
    },
    setSelfCheckType(state,type){
      state.selfCheckType = type
    },
    setRow_column_display_num(state, row_column_display_num) {
      state.row_column_display_num = row_column_display_num
    },
    setAutoAccept(state,auto) {
      state.autoAccept = auto
    },
    setShowStatus(state, ShowStatus) {
      state.showStatus = ShowStatus
    },
    setShowBroadCast(state, showBroadCast) {
      state.showBroadCast = showBroadCast
    },
    setPlay_Type(state, play_type) {
      state.play_type = play_type
    },
    setAlarmExten(state,alarmExten) {
      state.alarmExten = alarmExten
    },
    setAlarmType(state, alarmType) {
      state.alarmType = alarmType
    },
    setClearSearch(state, clearSearch) {
      state.clearSearch = clearSearch
    },
    setExt(state,ext){
      state.ext = ext
    },
    setCall(state, call) {
      state.call = call
    },
    setWhitePhoneSelected(state, val) {
      state.whitePhoneSelected = val
    },
    setHangup(state, hangup) {
      state.hangup = hangup
    },
    setHangExten(state, hangExten) {
      state.hangExten = hangExten
    },
    setVideoModal(state, videoModal) {
      state.videoModal = videoModal
    },
    setModalCameras(state, modalCameras) {
      state.modalCameras = modalCameras
    },
    setAlarm(state,alarm) {
      state.alarm = alarm
    },
    setAlarmId(state, alarmId) {
      state.alarmId = alarmId
    },
    setInfoExt(state, infoExt) {
      state.infoExt = infoExt
    },
    setStatus(state,status){
      state.status = status
    },
    setDeviceName(state, deviceName) {
      state.deviceName = deviceName
    },
    setDeptId(state,deptId){
      state.deptid = deptId
    },
    setDeptName(state,deptName){
      state.deptname = deptName
    },
    setNetwork(state,netWork){
      state.network = netWork
    },
    setBroadTypeId(state, broadTypeId) {
      state.broadTypeId = broadTypeId
    },
    setBroadTypeName(state, broadTypeName) {
      state.broadTypeName = broadTypeName
    },
    setMenuId(state,menuId) {
      state.menuId = menuId
    },
    setHiddenMenuId(state,hiddenMenuId) {
      state.hiddenMenuId = hiddenMenuId
    },
    setNoticeTypeId(state, noticeTypeId) {
      state.noticeTypeId = noticeTypeId
    },
    setNoticeTypeName(state, noticeTypeName) {
      state.noticeTypeName = noticeTypeName
    },
    setActionPlanId(state, actionPlanId) {
      state.actionPlanId = actionPlanId
    },
    setActionPlanName(state, actionPlanName) {
      state.actionPlanName = actionPlanName
    },
    setReportingInformationId(state, reportingInformationId) {
      state.reportingInformationId = reportingInformationId
    },
    setReportingInformationName(state, reportingInformationName) {
      state.reportingInformationName = reportingInformationName
    },
    setLinkGroupId(state, linkGroupId) {
      state.linkGroupId = linkGroupId
    },
    setLinkGroupName(state, linkGroupName) {
      state.linkGroupName = linkGroupName
    },
    setLinkGroupIsPublic(state,linkGroupIsPublic) {
      state.linkGroupIsPublic = linkGroupIsPublic
    },
    setLinkGroupDeptId(state,linkGroupDeptId) {
      state.linkGroupDeptId = linkGroupDeptId
    },
    setAlarmTypeId(state, alarmTypeId) {
      state.alarmTypeId = alarmTypeId
    },
    setAlarmArea(state, alarmArea) {
      state.alarmArea = alarmArea
    },
    setMapDevice(state,mapDevice) {
      state.mapDevice = mapDevice
    },
    setClickMapLeft(state, clickMapLeft) {
      state.clickMapLeft = clickMapLeft
    },
    setMapType(state, mapType) {
      state.mapType = mapType
    },
    setEditMap(state, editMap) {
      state.editMap = editMap
    },
    setMapGroupId(state, mapGroupId) {
      state.mapGroupId = mapGroupId
    },
    setMapGroupName(state, mapGroupName) {
      state.mapGroupName = mapGroupName
    },
    setCamera(state,camera) {
      state.camera = camera
    },
    setCameraGroupName(state, name) {
      state.cameraGroupName = name
    },
    setNeedFresh(state, needFresh) {
      state.needFresh = needFresh
    },
    setClickSystemId(state,id){
      state.clickSystemId = id
    },
    setClickSystemName(state,name){
      state.clickSystemName = name
    },
    setClickSystemAppKey(state, appKey) {
      state.clickSystemAppKey = appKey
    }

  },
  actions:{
  }
}



// WEBPACK FOOTER //
// ./src/store/module/clickData.js